import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  nameOfContentSelector,
  departmentOfContentSelector,
} from '../../ducks/content'
import { menuSelector } from '../../ducks/menu'
import MenuItem from './MenuItem'
import Hidden from '@material-ui/core/Hidden'
import HorizontalSlider from '../../../common/HorizontalSlider'

import styles from './menu.module.scss'

function Menu({ menu, categoryName, departmentName, style }) {
  return (
    <div className={styles.root} style={style}>
      <Hidden mdDown>
        <div className={styles.menu}>
          {menu.map(({ name, title, path, children }) => (
            <MenuItem
              key={name}
              href={path}
              items={children}
              active={name === departmentName}
              deepActiveName={categoryName}
              level={0}
            >
              {title}
            </MenuItem>
          ))}
        </div>
      </Hidden>
      <Hidden lgUp>
        <HorizontalSlider
          dots={false}
          arrows={false}
          swipeToSlide={true}
          slidesToShow={menu.length}
          variableWidth
          infinite={false}
          className={styles.slider}
          initialSlide={menu.findIndex((el) => el.name === departmentName)}
          responsive={[
            {
              breakpoint: 1250,
              settings: {
                slidesToShow: 3,
              },
            },
          ]}
        >
          {menu.map(({ name, title, path, children }) => (
            <MenuItem
              key={name}
              href={path}
              items={children}
              active={name === departmentName}
              deepActiveName={categoryName}
              level={0}
            >
              {title}
            </MenuItem>
          ))}
        </HorizontalSlider>
      </Hidden>
    </div>
  )
}

Menu.propTypes = {
  menu: PropTypes.array,
  categoryName: PropTypes.string,
  departmentName: PropTypes.string,
}

const mapStateToProps = (state) => ({
  menu: menuSelector(state),
  categoryName: nameOfContentSelector(state),
  departmentName: departmentOfContentSelector(state),
})

export default connect(mapStateToProps)(Menu)
